/**
 * Trim a value and collapse every run of whitespace inside it to one space.
 *
 * The spreadsheet this cellar comes from carries 34 cells with a leading tab
 * or a trailing space — `\tMarc Hébrart` and `Marc Hébrart` are one producer,
 * and untrimmed they become two. Every path that accepts a name runs it
 * through here first: the registration picker, the write path, and the
 * importer. Normalising in one place is what stops them drifting apart.
 *
 * This is deliberately only about whitespace. Case folding, accent folding
 * and near-match scoring belong to the matching function, not to storage —
 * the value written to the database keeps the spelling the owner chose.
 */
export function collapseWhitespace(value) {
    return value.replace(/\s+/gu, " ").trim();
}
/**
 * Whether a value carries the Unicode replacement character, U+FFFD.
 *
 * Nobody types one. It is what a decoder writes when the bytes it was given
 * were not the encoding it was told to expect — so its presence means the text
 * was already damaged before it arrived, and the original characters are gone.
 *
 * Storing it is worse than refusing it. `60-årspresent` becomes
 * `60-<?>rspresent` and stays that way for twenty years, looking like something
 * somebody meant to write. Found when a test client sent Latin-1 bytes to a
 * UTF-8 endpoint and the row came back with the å destroyed.
 */
export function looksMisencoded(value) {
    return value.includes("\uFFFD");
}
//# sourceMappingURL=text.js.map